/*
 * The Data table facetted filter's english translation.
 */
export const DATA_TABLE_FACETED_FILTER_EN = {
  selectFeed: 'Select Feed',
  searchFeed: 'Search Feed',
  selectItem: 'Select {item}',
  numOfSelected: '{num} selected...',
  searchItem: 'Search {item}'
}
/*
 * The Data table facetted filter's german translation.
 */
export const DATA_TABLE_FACETED_FILTER_DE = {
  selectFeed: 'Feed auswählen',
  searchFeed: 'Feed suchen',
  selectItem: '{item} auswählen',
  numOfSelected: '{num} ausgewählt...',
  searchItem: '{item} suchen'
}
